<mat-card>
  <mat-card-title>AutoFill Fields To Map To</mat-card-title>
  <mat-card-content>
    @for (currentMapping of this.currentMappings; track currentMapping; let currentMappingIndex = $index) {
      <div layout="column">
        <div fxLayout="row wrap" fxLayoutAlign="start baseline" fxLayoutGap="10px">
          <mat-select class="select-medium"
            placeholder="Field Name"
            title="Field Name"
            [(ngModel)]="currentMapping.field"
            (selectionChange)="stepFieldChanged(currentMapping)">
            @for (field of this.stepFields; track field) {
              <mat-option [value]="field">{{ field.FieldId }}</mat-option>
            }
          </mat-select>
          @for (propertyMapping of validPropertyMappings(currentMapping.propertyMappings); track propertyMapping) {
            <span>
              <span style="min-height: 40px">
                <mat-select class="select-medium"
                  placeholder="{{ propertyMapping.fieldProperty }}"
                  title="{{ propertyMapping.fieldProperty }}"
                  [(ngModel)]="propertyMapping.lookupField"
                  (selectionChange)="mappingFieldChanged()">
                  @for (field of this.potentialMappingFields; track field) {
                    <mat-option [value]="field">{{ field.name }}</mat-option>
                  }
                </mat-select>
              </span>
            </span>
          }
          <button mat-icon-button type="button" (click)="removeMapping(currentMappingIndex)" color="warn">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
  </mat-card-content>
  <mat-card-actions class="align-right">
    <button mat-raised-button type="button" (click)="addNewMapping()" color="primary">Add New Mapping</button>
  </mat-card-actions>
</mat-card>